<template>
  <card class="document-settings">
    <div class="row">
      <div class="col-12 col-sm-3 col-xl-12">
        <h4 class="document-settings__title">{{ title }}</h4>
      </div>
      <div class="col-12 col-sm-6 col-xl-12" :class="form ? 'col-sm-6' : 'col-sm-9'">
        <slot name="body"></slot>
      </div>
      <div class="col-12 col-sm-3 col-xl-12">
        <slot name="actions"></slot>
      </div>
    </div>
  </card>
</template>
<script>
export default {
  props: {
    title: String,
    form: Boolean
  }
};
</script>